module.exports = __webpack_public_path__ + "img/QR2.1731aef7.jpg";